<template>
	<b-nav-item-dropdown menu-class="media-list dropdown-menu-right" toggle-class="f-s-14" style="left:-40px;" class="notifications" no-caret >
		<template slot="button-content" >
			<i class="fa fa-bell" @click="resetNotificationCount"  style="color:#000 !important"></i>
			<span class="label" :class="{'bg-red' : newNotification > 0}">{{newNotification}}</span>
		</template>
		<b-dropdown-header>NOTIFICATIONS ({{newNotification}})</b-dropdown-header>
		<b-dropdown-item  v-for="(notification , index) in listOfNotifications" :key="index" @click="goToWorkOrderDetail(notification.data)" style="width:300px;border-bottom:1px solid #D3D3D3;" :class="{'bg-orange-color' : notification.new == 1}">
			<template v-if="notification.subject == 'work-order'">
				<p class="text-right">{{moment(notification.data.created_at).format("MMM, DD YYYY HH:mm")}}</p>
				<div class="row" style="min-height:80px" >
					<div class="col-4">
						<i :class="`fa ${notification.step.icon} fa-3x`"></i>
					</div>
					<div class="col-8" style="word-wrap:break-word;">
						<p style=" 
						display: block;
						width: 100%;
						overflow:hidden;
						white-space: normal;" 
						>
							{{notification.message}}
						</p>
					</div>
				</div>
			</template>
			<template v-else-if="notification.subject == 'estimation'">
				<p class="text-right">{{moment(notification.data.created_at).format("MMM, DD YYYY HH:mm")}}</p>
				<div class="row" style="min-height:80px" >
					<div class="col-4">
						<i :class="`fa fa-balance-scale fa-3x`"></i>
					</div>
					<div class="col-8" style="word-wrap:break-word;">
						<p style=" 
						display: block;
						width: 100%;
						overflow:hidden;
						white-space: normal;" 
						>
							{{notification.message}}
						</p>
					</div>
				</div>
			</template>
			<template v-else-if="notification.subject == 'PO Sparepart'">
				<p class="text-right">{{moment(notification.data.created_at).format("MMM, DD YYYY HH:mm")}}</p>
				<div class="row" style="min-height:80px" >
					<div class="col-4">
						<i :class="`fa fa-truck-loading fa-3x`"></i>
					</div>
					<div class="col-8" style="word-wrap:break-word;">
						<p style=" 
						display: block;
						width: 100%;
						overflow:hidden;
						white-space: normal;" 
						>
							{{notification.message}}
						</p>
					</div>
				</div>
			</template>
		</b-dropdown-item>
	</b-nav-item-dropdown>
</template>

<script>
import moment from 'moment'
export default {
	data() {
		return {
			listOfNotifications : [],
			newNotification : 0,
			buttonClickCount : 0,
			moment : moment
		}
	},
	mounted () {
		this.loadNotifications()
		// this.$sockets.subscribe('workOrder', (data) => {
		// 	console.log(data)
		// });

	},
	methods : {
		loadNotifications () {
			this.$http.get('/api/v1/notification')
			.then((resp) => {
				this.listOfNotifications = resp.data.data

				for(var i = 0 ; i < this.listOfNotifications.length ; i++) {
					this.listOfNotifications[i].new = 0;
					this.listOfNotifications[i].step = this.listOfNotifications[i].step_data
				}
				// console.log(this.listOfNotifications)
			})
			.catch((err)=> {
				console.log(err)
			})
		},
		resetNotificationCount() {
			if(this.buttonClickCount == 0){
				this.buttonClickCount++
			}
			else{
				this.newNotification = 0
				this.buttonClickCount = 0
				for(var i = 0 ; i < this.listOfNotifications.length ; i++) {
					this.listOfNotifications[i].new = 0;
				}
			}
			
		},
		goToWorkOrderDetail(data) {
			this.$router.push('/work-order-detail?wo=' + data.work_order_code)
		}
	},
	sockets: {
		'work-order' : function (data) {
			console.log(data)
			data.new = 1
			this.listOfNotifications.splice(0 , 0 , data)
			console.log(this.listOfNotifications)
			this.newNotification++;

			let title = data.subject == 'PO Sparepart' ? data.subject : 'Notifikasi Untuk ' + data.data.work_order_code
			this.$notification.show(title, {
				body: data.message
			}, {})
		}
	}
}
</script>

<style scoped>
	.bg-orange-color {
		background-color : rgba(252, 214, 112, 0.3)
	}
</style>

<style>
	.notifications ul {
		max-height:500px;
		overflow-y: scroll;
	}
</style>